import { render, staticRenderFns } from "./HomePageProposal.vue?vue&type=template&id=a84f863a&scoped=true&"
var script = {}
import style0 from "./HomePageProposal.vue?vue&type=style&index=0&id=a84f863a&lang=scss&scoped=true&"
import style1 from "./HomePageProposal.vue?vue&type=style&index=1&id=a84f863a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84f863a",
  null
  
)

export default component.exports